
import { BrowserRouter as Router, Route, Routes, Link, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import DeleteAccount from './pages/DeleteAccount';
import Faq from './pages/Faq';
import Items from './pages/Item';
import SEOSchema from './components/seo/SEOSchema';
import ForBusiness from './pages/ForBusiness';
import Contact from './pages/Contact';
import ItemList from './pages/ItemList';
import ItemView from './pages/ItemView';
import BlogList from './pages/BlogList';
import BlogPost from './pages/BlogPost';
import BannerLanding from './pages/BannerLanding';

import './css/App.css';
import './css/styles.css';
import Footer from './components/Footer';


import { useRef, useLayoutEffect, useState } from 'react';

const Header = () => {
  const location = useLocation();
  const navRef = useRef(null);
  const [indicatorStyle, setIndicatorStyle] = useState({ left: 0, width: 0, opacity: 0 });
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isActive = (path) => {
    if (path === '/items' && location.pathname === '/itemlist') return 'active';
    if (location.pathname.startsWith('/itemlink/') && path === '/items') return 'active';
    return location.pathname === path ? 'active' : '';
  };

  useLayoutEffect(() => {
    const activeLink = navRef.current?.querySelector('a.active');
    if (activeLink && navRef.current) {
      const navRect = navRef.current.getBoundingClientRect();
      const linkRect = activeLink.getBoundingClientRect();
      setIndicatorStyle({
        left: linkRect.left - navRect.left,
        width: linkRect.width,
        opacity: 1
      });
    } else {
      setIndicatorStyle(prev => ({ ...prev, opacity: 0 }));
    }
  }, [location.pathname]);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className="bg-white position-relative shadow-sm" style={{ zIndex: 1000 }} role="banner">
      <div className="header-container d-flex align-items-center justify-content-between w-100 px-4 mb-0 border-0 shadow-none">
        <div className="logo d-flex align-items-center">
          <Link to="/" onClick={closeMenu}>
            <img src="/images/textlogo.png" alt="ToyTrade Logo" style={{ maxWidth: '138px', height: 'auto' }} />
          </Link>
        </div>

        {/* Mobile Toggle Button */}
        <button
          className="btn btn-link d-lg-none text-dark p-0 border-0 shadow-none menu-toggle-btn"
          onClick={toggleMenu}
          aria-label="Toggle navigation"
        >
          <i className={`bi ${isMenuOpen ? 'bi-x-lg' : 'bi-list'} fs-1`}></i>
        </button>

        <nav className={`topnav h-100 d-flex align-items-center ${isMenuOpen ? 'mobile-show' : ''}`} ref={navRef}>
          <div className="nav-indicator d-none d-lg-block" style={indicatorStyle}></div>
          <ul className="list-unstyled mb-0 d-flex nav-list">
            <li className="mx-lg-4 fs-5">
              <Link to="/" className={isActive('/')} onClick={closeMenu}>Home</Link>
            </li>
            <li className="mx-lg-4 fs-5">
              <Link to="/items" className={isActive('/items')} onClick={closeMenu}>All Items</Link>
            </li>
            <li className="mx-lg-4 fs-5">
              <Link to="/faq" className={isActive('/faq')} onClick={closeMenu}>FAQ</Link>
            </li>
            <li className="mx-lg-4 fs-5">
              <Link to="/for-business" className={isActive('/for-business')} onClick={closeMenu}>For Business</Link>
            </li>
            <li className="mx-lg-4 fs-5">
              <Link to="/contact" className={isActive('/contact')} onClick={closeMenu}>Contact</Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};



const organizationData = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "ToyTrade.pk",
  "url": "https://toytrade.pk",
  "logo": "https://toytrade.pk/images/textlogo.png",
  "sameAs": [
    "https://www.facebook.com/toytrade.pk",
    "https://www.instagram.com/toytrade.pk"
  ]
};

function App() {
  return (
    <>
      <SEOSchema data={organizationData} />
      <Router>
        <div className="App">
          <main className="main-container container-xxl bg-white p-0  ">
            <Header />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/items" element={<Items />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/delete-account" element={<DeleteAccount />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/for-business" element={<ForBusiness />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/itemlist" element={<ItemList />} />
              <Route path="/itemlink/:itemId" element={<ItemView />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/landing" element={<BannerLanding />} />
            </Routes>
            <Footer />
          </main>
        </div>
      </Router>
    </>
  );
}

export default App;
